import { render, staticRenderFns } from "./InstrukturTambah.vue?vue&type=template&id=3ac15385&scoped=true&"
import script from "./InstrukturTambah.vue?vue&type=script&lang=js&"
export * from "./InstrukturTambah.vue?vue&type=script&lang=js&"
import style0 from "./InstrukturTambah.vue?vue&type=style&index=0&id=3ac15385&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac15385",
  null
  
)

export default component.exports